class Observable {
  constructor() {
    this.observer = {};
  }

  subscribe(item) {
    this.observer = {
      ...this.observer,
      ...item,
    };
  }

  unsubscribe(item) {
    delete this.observer[item];
  }

  reset() {
    this.observer = {};
  }

  notify() {
    return this.observer;
  }
}

export const observable = new Observable();
